import { render } from "./dashboard-page.vue?vue&type=template&id=a7adc192&ts=true"
import script from "./dashboard-page.ts?vue&type=script&lang=ts"
export * from "./dashboard-page.ts?vue&type=script&lang=ts"

import "./dashboard-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__